<template>
<th v-if="isHeader" class="vuetable-th-component-checkbox">
    <input
      v-if="!checkLimit"
      type="checkbox" @change="toggleAllCheckbox($event)" :checked="isAllItemsInCurrentPageSelected()">
</th>
<td v-else :class="['vuetable-td-component-checkbox',('displayNone' in rowData) && rowData.displayNone && rowData.is_cancel ? 'd-none' : '']">
    <span v-if="rowField.loading && rowField.loading(rowData) == 'checkmark'" class="" style="width: 18px; height: 18px; border-width: 2px; position: relative;top: 0px;"><i class="icon-checkmark3 text-success"></i></span>
    <span v-else-if="rowField.loading && rowField.loading(rowData) == 'cross'" class="" style="width: 18px; height: 18px; border-width: 2px; position: relative;top: 0px;"><i class="icon-cross2 text-danger"></i></span>
    <span v-else-if="rowField.loading? rowField.loading(rowData): false" class="loading-sm" style="width: 18px;height: 18px;border-width: 2px;position: relative;top: 0px;"></span>
    <input v-else type="checkbox" :disabled="rowField.disabled? rowField.disabled(rowData): false" :style="rowField.disabled(rowData)? 'opacity: 0.5;': ''" @change="toggleCheckbox(rowData, $event)" :checked="isSelected(rowData)">
</td>
</template>

<script>
import VuetableFieldCheckboxMixin from "vuetable-2/src/components/VuetableFieldCheckboxMixin.vue";
import Cookies from "js-cookie";
export default {
    name: 'vuetable-field-checkbox-loader',
    mixins: [VuetableFieldCheckboxMixin],

    data() {
    return {
      checkLimit: ["free", "basic"].includes(JSON.parse(Cookies.get('plan')).series)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/vuetable-checkbox/VuetableFieldCheckboxLoadWarehouse.vue